<template>
  <DataTable
    ref="dataTable"
    title="Custom Translations"
    :endpoint="`partners/${partner.id}/sites/${site.id}/custom-translations`"
  >
    <template v-slot:buttons>
      <Button type="primary" @click="newPartnerSiteCustomTranslation()"><Icon icon="plus" /></Button>
    </template>

    <template v-slot:rows="rows">
      <DataTableRow v-for="(row, i) in rows" :key="i" :row="row">
        <DataTableColumn icon="key" icon-prefix="far" title="Language" sortable="key" width="max">
          <div class="flex items-center space-x-2">
            <span class="text-xl">{{ row.language.icon }}</span>
            <span class="text-xs font-medium uppercase text-primary">{{ row.language.name }}</span>
          </div>
        </DataTableColumn>
        <DataTableColumn icon="key" icon-prefix="far" title="Key" sortable="key" width="max">
          <code class="text-sm font-medium">{{ row.key }}</code>
        </DataTableColumn>
        <DataTableColumn title="Value" sortable="value">
          <code class="text-sm font-medium">{{ row.value }}</code>
        </DataTableColumn>
        <DataTableColumn title="Updated" width="max" sortable="updated_at">{{
          row.updated_at | datetime
        }}</DataTableColumn>
        <template v-slot:actions>
          <Dropdown icon="ellipsis-v" class="flip-menu">
            <DropdownLink icon="pencil" @click="editPartnerSiteCustomTranslation(row)">Edit</DropdownLink>
            <DropdownLink icon="trash" @click="deletePartnerSiteCustomTranslation(row)">Delete</DropdownLink>
          </Dropdown>
        </template>
      </DataTableRow>
    </template>
  </DataTable>
</template>

<script>
import EditPartnerSiteCustomTranslationModal from "../../../modals/Partners/EditPartnerSiteCustomTranslationModal.vue"
import NewPartnerSiteCustomTranslationModal from "../../../modals/Partners/NewPartnerSiteCustomTranslationModal.vue"

export default {
  props: {
    partner: {
      type: Object,
      required: true
    },
    site: {
      type: Object,
      required: true
    }
  },

  methods: {
    async newPartnerSiteCustomTranslation() {
      await this.$modal.show(NewPartnerSiteCustomTranslationModal, {
        partner_id: this.partner.id,
        site_id: this.site.id
      })

      this.$refs.dataTable.reload()
    },
    async editPartnerSiteCustomTranslation(customTranslation) {
      await this.$modal.show(EditPartnerSiteCustomTranslationModal, {
        partner_id: this.partner.id,
        site_id: this.site.id,
        custom_translation_id: customTranslation.id
      })

      this.$refs.dataTable.reload()
    },
    async deletePartnerSiteCustomTranslation(customTranslation) {
      if (
        await this.$modal.confirm({
          type: "danger",
          message: `Are you sure you want to delete **${customTranslation.key}**? This is **irreversible and will permanently delete** this custom translation.`,
          buttonText: "Delete"
        })
      ) {
        if (
          await this.$api.delete(
            `partners/${this.partner.id}/sites/${this.site.id}/custom-translations/${customTranslation.id}`
          )
        ) {
          this.$notification.success(`Custom translation **${customTranslation.key}** successfully deleted.`)

          this.$refs.dataTable.reload()
        }
      }
    }
  }
}
</script>
